import React from "react"

import { useScrollAnim } from "src/components/hooks/hooks"
import { Link } from "components/anti/link/link"

export const ProjectDetailsHeadline = ({ data, eBrochures, lang, title, slug, city, datalayerAdd }) => {
    const [trigger, anim] = useScrollAnim()
    const rootUrl = process.env.GATSBY_ROOT_URL

    const idFile = eBrochures && eBrochures[0].pdfFiles.file.databaseId

    const datalayerPush = () => {
        const value = {
            'event': 'DownloadBrochure',
            'page_url': window.location.href, // entire string of current page URL including UTM parameter and hash # if any
            'page_title': title,
            'content_type': 'home_listing',
            'content_id': slug, // any IDs in your listing catalog, example: 'Provence Suites'
            'city': city, // provide the user's city of the interest, example 'BSD City'
            'region': city, // state, district, or region of interest, example 'South Tangerang' 'country': 'country' // target country of the interest, example 'Indonesia'
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(value)
    }

    return (
        <section className="pt-main" ref={trigger}>
            <div className="container mw-xl">
                <div className="w-md-750px">
                    <h2 className={`${anim(1)}`}>{data.title}</h2>
                    <p className={`${anim(2)}`}>{data.text}</p>
                </div>
                <div className="row">
                    {eBrochures && (
                        <div className="col-md-3" >
                            <div onClick={() => datalayerPush()}>
                                <a
                                    className={`btn btn-link ${anim(3)}`}
                                    href={`${rootUrl}/download/index.php?id=${idFile}`}
                                    target="_blank"
                                >
                                    {lang === "en" ? "Download Brochure" : "Unduh Brosur"}
                                </a>
                            </div>
                        </div>
                    )}
                    <div className="col-md-3">
                        <Link to="#get-more-info" className={`btn btn-link ${anim(4)}`} target={null}>
                            {lang === "en" ? "Get More Info" : "Informasi Lebih Lanjut"}
                        </Link>
                    </div>
                </div>
            </div>
        </section >
    )
}